'use strict';

/**
 * @classname Filter
 * @classdesc 絞り込み
 */
export default class Filter {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--filter-area
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$listItem = $('.list__item--school');
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof Filter
	 * @return undefined
	 */
	onClick() {
		this._$listItem.hide();
		let schoolYear = $('#filter-school-year').val();
		let coeducation = $('#filter-coeducation').val();
		let curriculum = $('#filter-curriculum').val();
		let entryYear = $('#filter-entry-year').val();
		if(schoolYear == '' && coeducation == '' && curriculum == '' && entryYear == '') {
			$('.total-num').text(`ALL`);
			this._$listItem.show();
			return;
		}
		let cnt = 0;
		this._$listItem.each((idx, e) => {
			const $e = $(e);
			let push = true;
			if(schoolYear != '') {
				if(!$e.attr('data-school-year').match(schoolYear)) {
					push = false;
				}
			}
			if(coeducation != '') {
				let coeducationFromServer = $e.data('coeducation');
				if(coeducationFromServer == 4) coeducationFromServer = 1;
				if(coeducationFromServer != coeducation) push = false;
			}
			if(curriculum != '') {
				if(!$e.data('curriculum') || $e.data('curriculum') == '' || $e.data('curriculum') == '4') push = false;
				if(curriculum == 1 && $e.data('curriculum') == '2') push = false;
				if(curriculum == 2 && $e.data('curriculum') == '1') push = false;
			}
			if(entryYear != '') {
				if(!$e.attr('data-entry-year').match(entryYear)) {
					push = false;
				}
			}
			if(push) {
				console.log(idx);
				$('.list__item--school').eq(idx).show();
				cnt ++;
			}
		})
		$('.total-num').text(`全${cnt}件`);
	}
};
